module.exports = __webpack_public_path__ + "img/podium_3456.bcc97f61.jpg";